module.exports = __webpack_public_path__ + "static/media/icon.f94a5ae1.png";